// extracted by mini-css-extract-plugin
module.exports = {"button":"UnexpectedError_button__XNCaG","container-grid":"UnexpectedError_container-grid__sViTP","text":"UnexpectedError_text__uOAcy"};